import React, { useState, useEffect } from "react"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import "./phoneInput.scss"

const DEFAULT_FALLBACK = "us"

const PhoneCustomInput = props => {
  const [country, setCountry] = useState(
    props.defaultCountry || DEFAULT_FALLBACK
  )

  useEffect(() => {
    const next = props.defaultCountry || DEFAULT_FALLBACK
    if (next !== country) setCountry(next)
  }, [props.defaultCountry])

  return (
    <PhoneInput
      placeholder={props.placeholder || "Contact Number"}
      country={country}
      value={props.value}
      isValid={props.isValid}
      onChange={props.onChange}
      inputClass={props.inputClass ? props.inputClass : ""}
      containerClass={props.containerClass || "phoneSelect"}
      onFocus={props.onFocus}
      enableClickOutside={true}
      inputProps={props.inputProps}
      buttonProps={{
        "aria-label": "Select country",
      }}
    />
  )
}

export default PhoneCustomInput
